module.exports = __webpack_public_path__ + "static/media/dartmouth.3c524df7.png";